import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer-container">
      
      {/* Brand & Description */}
      <div className="footer-brand">
        <img
          src={`${process.env.PUBLIC_URL}/assets/img/Group%20494.svg`}
          alt="DigitMoney"
          className="footer-logo-img"
        />
        
        <p className="footer-desc">
          DigitMoney helps you explore gold loan options from trusted, RBI-regulated lending partners.
        </p>
        <p className="footer-desc">
          DigitMoney is a loan comparison platform. We are not a lender. Loans are subject to lender approval.
        </p>
      </div>

      {/* Links Grid (2 Columns) */}
      <div className="footer-links-grid">
        <div className="footer-column">
          <h4 className="footer-col-title">NAVIGATION</h4>
          <ul className="footer-list">
            <li><a href="#process">How it works</a></li>
            <li><a href="#faqs">FAQ</a></li>
            <li><a href="https://digitmoney.in/lending-partners">Partners</a></li>
            <li><a href="https://digitmoney.in/">About us</a></li>
          </ul>
        </div>
        
        <div className="footer-column">
          <h4 className="footer-col-title">LEGAL</h4>
          <ul className="footer-list">
            <li><a href="https://digitmoney.in/privacy-policy">Privacy Policy</a></li>
            <li><a href="https://digitmoney.in/terms">Terms of Use</a></li>
            <li><a href="#">Cookie Policy</a></li>
            <li><a href="https://digitmoney.in/contact-us">Contact Us</a></li>
          </ul>
        </div>
      </div>

      {/* Grievance Officer */}
      <div className="footer-grievance">
        <p>Grievance Redressal Officers<br/>
        Ammy Pinheiro: <a href="mailto:grievance@digitmoney.in">grievance@digitmoney.in</a></p>
      </div>

      {/* Social Media (Join Us) */}
      <div className="footer-social">
        <h4 className="footer-col-title">JOIN US</h4>
        <div className="social-icons-wrapper">
          {/* Swapped text for image tags. Update the filenames to match your exported images! */}
          <a href="https://www.facebook.com/DigitMoneyTechnologies" className="social-icon">
            <img src="/assets/img/facebookIcon.svg" alt="Facebook" />
          </a>
          <a href="https://www.instagram.com/digitmoney.india" className="social-icon">
            <img src="/assets/img/InstaIcon.svg" alt="Instagram" />
          </a>
          <a href="https://www.linkedin.com/company/digitmoney" className="social-icon">
            <img src="/assets/img/LinkedInIcon.svg" alt="LinkedIn" />
          </a>
          <a href="https://www.youtube.com/@DigitMoneyIndia" className="social-icon">
            <img src="/assets/img/youtubeIcon.svg" alt="YouTube" />
          </a>
          <a href="https://twitter.com/DigitMoneyIndia" className="social-icon">
            <img src="/assets/img/twitterIcon.svg" alt="X" />
          </a>
          <a href="https://api.whatsapp.com/send/?phone=9076324177&type=phone_number&app_absent=0" className="social-icon">
            <img src="/assets/img/whatsappIcon.svg" alt="WhatsApp" />
          </a>
        </div>
      </div>

      {/* Bottom Copyright Banner */}
      <div className="footer-bottom">
        <p>© 2025, DigitMoney Technologies Private Limited. All Rights Reserved.</p>
        <div className="footer-bottom-links">
          <a href="https://digitmoney.in/terms">Terms of Use</a>
          <a href="https://digitmoney.in/privacy-policy">Privacy Policy</a>
        </div>
      </div>

    </footer>
  );
}